import castArray from 'lodash-es/castArray'
import get from 'lodash-es/get'
import uniq from 'lodash-es/uniq'
import * as React from 'react'

import { IItemCard } from '../interface'

import * as styles from './lockupFilesIncluded.module.css'

const LockupFilesIncluded = ({ item }: IItemCard) => {
  const { attributes } = item

  const filesAttribute = attributes.find(attr =>
    attr.name.includes('files-included')
  )

  const fileTypes = get(filesAttribute, 'value') || []

  const attributeNames = {
    'Photoshop PSD': 'PSD',
    'InDesign INDD': 'INDD',
    'Quark QXP': 'QXP',
    'Vector EPS': 'EPS',
    'JPG Image': 'JPG',
    'AI Illustrator': 'AI',
    'TIFF Image': 'TIFF',
    'Photoshop ABR': 'ABR',
    'Photoshop GRD': 'GRD',
    'Photoshop PAT': 'PAT',
    'Photoshop ASL': 'ASL',
    'Photoshop ATN': 'ATN',
    'Photoshop CSH': 'CSH',
    'Photoshop HDR': 'HDR',
    'Photoshop JSX': 'JSX',
    'ZXP file': 'ZXP'
  }

  if (!fileTypes || !fileTypes.length) {
    return null
  }

  return (
    <>
      <span className={styles.label}>Files Types Included:</span>
      <ul>
        {uniq(castArray(fileTypes)).map((fileType, index) => (
          <li className={styles.fileType} key={index}>
            {get(attributeNames, fileType, fileType)}
          </li>
        ))}
      </ul>
    </>
  )
}

export default LockupFilesIncluded
